import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import ForgotPasswordContent from "../../components/Pages/Auth/ForgotPassword";
import Layout from "../../components/Layout";

const { displayName } = config;

export default function ChangePassword(): React.ReactNode {
  useEffect(() => {
    document.title = `${displayName}: Forgot password`;
  }, []);

  return (
    <Layout transparent>
      <ForgotPasswordContent title="Change your password?" />
    </Layout>
  );
}
